<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="content min-vh-100 flex-column d-flex justify-content-between">
					<section>
						<h2 class="title">
							<img src="/img/ico-cover-stay.svg" />{{ title }}
						</h2>
						<p>
							<b>{{ intro }}</b>
						</p>
						<div class="accordion" role="tablist">
							<b-card v-for="(coverage, coverage_key) in coverages" :key="coverage_key" no-body class="mb-1">
								<div class="card-header">
									<h6>
										<button v-b-toggle="'coverage-'+coverage_key" class="btn btn-link collapsed" type="button">
											{{ coverage.title }}
										</button>
									</h6>
								</div>
								<b-collapse :id="'coverage-'+coverage_key" accordion="my-accordion" role="tabpanel">
									<b-card-body v-for="(chapter, chapter_key) in coverage.chapters" :key="chapter_key">
										<b-card-title>{{ chapter.title }}</b-card-title>
										<b-card-text v-html="chapter.text"></b-card-text>
										<b-card-sub-title>LIMIT</b-card-sub-title>
										<b-card-text v-html="chapter.limit || '-'"></b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</section>
					<ReadAllTermsAndConditions/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReadAllTermsAndConditions from '@/components/ReadAllTermsAndConditions.vue'

export default {
	components: {
		ReadAllTermsAndConditions,
	},
	data(){
		return {
			title: "COVER STAY",
			intro: "In the event of health restrictions regarding the Insured Party, ordered by the competent authorities for safety reasons.",
			coverages: [
				{
					title: "IN THE EVENT OF HEALTH RESTRICTIONS, ORDERED BY THE COMPETENT AUTHORITY FOR SECURITY REASONS",
					chapters: [
						{
							title: "",
							text: "In the event of health restrictions regarding the Insured Party ordered by the competent authorities for safety reasons:<ul><li>at the time of arrival at the airport of the destination or transit country;</li><li>or during the Trip or stay in order to perform health examinations;</li><li>or in the case of a declaration of quarantine with forced stay in the location</li></ul>the Company shall reimburse any greater essential and indispensable costs for food and lodging sustained by the Insured Party for the forced stay and for Trip vouchers for return to the Residence or Domicile.",
							limit: "€ 2.500 per insured/annual aggregate"
						},
					]
				},
			]
		}
	}
}
</script>
